module.exports = __webpack_public_path__ + "img/us_scctnx.3365881c.png";